import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import addDays from 'date-fns/addDays';
import isFirstDayOfMonth from 'date-fns/isFirstDayOfMonth';
import type { IntlShape } from 'react-intl-next';

import { WEEK_DAY_COUNT } from '../constants';

const generateWeekDays = (intlApi: IntlShape) => (startEpoch: number, offset: number) =>
	[...Array.from({ length: WEEK_DAY_COUNT })].map((_, index) => {
		const start = addDays(startEpoch, index).valueOf();
		const end = addDays(startEpoch, index + 1).valueOf();

		const zoned = utcToZonedTime(start + offset, 'UTC');

		const isFirstDay = isFirstDayOfMonth(zoned);

		const text = isFirstDay
			? intlApi
					.formatDate(zoned, {
						day: 'numeric',
						month: 'short',
					})
					.toLocaleUpperCase(intlApi.locale)
			: intlApi.formatDate(zoned, { day: 'numeric' });

		return {
			dayStartEpoch: start,
			dayEndEpoch: end,
			isFirstDay,
			text,
		};
	});

export { generateWeekDays };
